/* ==========================================================================
   Furrivara — custom product page behaviour
   Added 2026-08-25. Namespaced, dependency-free, safe to remove wholesale.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- Money formatting (Shopify money_format string) -------------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || (window.theme && window.theme.settings && window.theme.settings.moneyWithCurrencyFormat) || '{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function num(n, precision, thousands, decimal) {
      if (isNaN(n) || n === null) return '0';
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return whole + frac;
    }

    var value = '';
    var match = fmt.match(placeholder);
    if (!match) return fmt;

    switch (match[1]) {
      case 'amount':                     value = num(cents, 2, ',', '.'); break;
      case 'amount_no_decimals':         value = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator':value = num(cents, 2, '.', ','); break;
      case 'amount_with_space_separator':value = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ''); break;
      default:                           value = num(cents, 2, ',', '.');
    }
    return fmt.replace(placeholder, value);
  }

  /* ---- Price row: literal savings amount, live on variant change --------- */
  function updatePrice(root, variant) {
    var el = root.querySelector('[data-fv-price]');
    if (!el || !variant) return;

    var fmt  = el.getAttribute('data-money-format');
    var label = el.getAttribute('data-save-label') || 'SAVE [amount]';
    var was  = el.querySelector('[data-fv-was]');
    var now  = el.querySelector('[data-fv-now]');
    var save = el.querySelector('[data-fv-save]');

    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (now) {
      now.textContent = formatMoney(variant.price, fmt);
      now.classList.toggle('fv-price__now--regular', !onSale);
    }
    if (was) {
      if (onSale) { was.textContent = formatMoney(variant.compare_at_price, fmt); was.hidden = false; }
      else { was.hidden = true; was.textContent = ''; }
    }
    if (save) {
      if (onSale) {
        // Literal difference, not a percentage — per brief.
        var diff = variant.compare_at_price - variant.price;
        save.textContent = label.replace('[amount]', formatMoney(diff, fmt));
        save.hidden = false;
      } else { save.hidden = true; save.textContent = ''; }
    }
  }

  /* ---- Low-stock bar ----------------------------------------------------- */
  function updateStock(root, variant) {
    var el = root.querySelector('[data-fv-stock]');
    if (!el) return;
    var fill = el.querySelector('[data-fv-stock-fill]');
    if (!fill) return;

    var pct = parseInt(el.getAttribute('data-fill'), 10);
    if (el.getAttribute('data-use-real') === 'true' && variant && typeof variant.inventory_quantity === 'number') {
      var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 10;
      var qty = variant.inventory_quantity;
      if (qty > 0) pct = Math.min(100, Math.round((qty / threshold) * 100));
    }
    if (isNaN(pct)) pct = 25;
    fill.style.width = pct + '%';
    // Bar colour is fixed red in CSS — intentionally never turns green.
  }

  document.addEventListener('on:variant:change', function (evt) {
    var root = evt.target.closest('.section-main-product') || document;
    var variant = evt.detail && evt.detail.variant;
    if (!variant) return;
    updatePrice(root, variant);
    updateStock(root, variant);
  });

  /* ---- Reviews: load more ------------------------------------------------ */
  function initReviewsLoadMore(scope) {
    (scope || document).querySelectorAll('[data-fv-review-more]').forEach(function (btn) {
      if (btn.dataset.fvBound) return;
      btn.dataset.fvBound = '1';
      btn.addEventListener('click', function () {
        var list = document.getElementById(btn.getAttribute('data-target'));
        if (!list) return;
        var step = parseInt(btn.getAttribute('data-step'), 10) || 3;
        var hidden = list.querySelectorAll('.fv-review[hidden]');
        for (var i = 0; i < step && i < hidden.length; i++) hidden[i].hidden = false;
        if (list.querySelectorAll('.fv-review[hidden]').length === 0) {
          btn.parentElement.hidden = true;
        }
      });
    });
  }

  /* ---- FAQ accordion ------------------------------------------------------ */
  function initFaq(scope) {
    (scope || document).querySelectorAll('[data-fv-faq-q]').forEach(function (btn) {
      if (btn.dataset.fvBound) return;
      btn.dataset.fvBound = '1';
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.hidden = open;
      });
    });
  }


  /* ---- Generic carousel ---------------------------------------------------
     Used by the community strip. Native scroll-snap does the movement, so
     touch/swipe and keyboard scrolling work for free; this only adds arrows,
     optional autoplay, and disabled-state bookkeeping.
     ----------------------------------------------------------------------- */
  function initCarousels(scope) {
    (scope || document).querySelectorAll('[data-fv-carousel]').forEach(function (root) {
      if (root.dataset.fvBound) return;
      root.dataset.fvBound = '1';

      var track = root.querySelector('[data-fv-track]');
      var prev  = root.querySelector('[data-fv-prev]');
      var next  = root.querySelector('[data-fv-next]');
      if (!track) return;

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function step() {
        var first = track.querySelector('.fv-community__item');
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      function atStart() { return track.scrollLeft <= 2; }
      function atEnd()   { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; }

      function sync() {
        if (prev) prev.disabled = atStart();
        if (next) next.disabled = atEnd();
      }

      function go(dir) {
        var loop = root.getAttribute('data-loop') === 'true';
        if (loop && dir > 0 && atEnd())   { track.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' }); return; }
        if (loop && dir < 0 && atStart()) { track.scrollTo({ left: track.scrollWidth, behavior: reduce ? 'auto' : 'smooth' }); return; }
        track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { go(-1); pause(); });
      if (next) next.addEventListener('click', function () { go(1);  pause(); });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { sync(); ticking = false; });
      });
      window.addEventListener('resize', sync);
      sync();

      /* autoplay */
      var timer = null;
      var delay = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 4000;
      var wants = root.getAttribute('data-autoplay') === 'true' && !reduce;

      function start() {
        if (!wants || timer) return;
        timer = setInterval(function () {
          if (document.hidden) return;
          if (atEnd()) track.scrollTo({ left: 0, behavior: 'smooth' });
          else go(1);
        }, delay);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function pause() { stop(); setTimeout(start, delay * 2); }

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
      start();
    });
  }

  function initAll(scope) { initReviewsLoadMore(scope); initFaq(scope); initCarousels(scope); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  // Re-bind after theme-editor section reloads.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
